var _a, _b, _c, _d, _e;
export var ROUTE;
(function (ROUTE) {
    ROUTE[ROUTE["BOOKMARK_LISTS"] = 0] = "BOOKMARK_LISTS";
    ROUTE[ROUTE["BOOKMARK_LIST"] = 1] = "BOOKMARK_LIST";
    ROUTE[ROUTE["USER_AUCTIONS"] = 2] = "USER_AUCTIONS";
    ROUTE[ROUTE["USER_SETTINGS"] = 3] = "USER_SETTINGS";
    ROUTE[ROUTE["USER_SERVICE"] = 4] = "USER_SERVICE";
})(ROUTE || (ROUTE = {}));
var MARKET;
(function (MARKET) {
    MARKET["DE"] = "de";
    MARKET["FR"] = "fr";
    MARKET["AT"] = "at";
    MARKET["CH"] = "ch";
})(MARKET || (MARKET = {}));
var routes = (_a = {},
    _a[MARKET.DE] = (_b = {},
        _b[ROUTE.BOOKMARK_LISTS] = "konto/merkzettel/listen",
        _b[ROUTE.BOOKMARK_LIST] = "merkzettel",
        _b[ROUTE.USER_SETTINGS] = "konto/einstellungen",
        _b[ROUTE.USER_AUCTIONS] = "auktionen/meine-auktionen",
        _b),
    _a[MARKET.CH] = (_c = {},
        _c[ROUTE.BOOKMARK_LISTS] = "konto/merkzettel/listen",
        _c[ROUTE.BOOKMARK_LIST] = "merkzettel",
        _c[ROUTE.USER_SETTINGS] = "konto/einstellungen",
        _c[ROUTE.USER_AUCTIONS] = "auktionen/meine-auktionen",
        _c),
    _a[MARKET.AT] = (_d = {},
        _d[ROUTE.BOOKMARK_LISTS] = "konto/merkzettel/listen",
        _d[ROUTE.BOOKMARK_LIST] = "merkzettel",
        _d[ROUTE.USER_SETTINGS] = "konto/einstellungen",
        _d[ROUTE.USER_AUCTIONS] = "auktionen/meine-auktionen",
        _d),
    _a[MARKET.FR] = (_e = {},
        _e[ROUTE.BOOKMARK_LISTS] = "compte/favoris/listes",
        _e[ROUTE.BOOKMARK_LIST] = "favoris",
        _e[ROUTE.USER_SETTINGS] = "compte/parametres",
        _e),
    _a);
var LoginRouter = /** @class */ (function () {
    function LoginRouter() {
    }
    LoginRouter.route = function (market, route, options) {
        var _a;
        if (options === void 0) { options = {}; }
        if (!routes[market] || !routes[market][route])
            market = MARKET.DE;
        if (!routes[market][route])
            throw new Error("route not defined for Market [" + market + "]: " + ROUTE[route]);
        var url = new URL(location.origin);
        (_a = options.queryParams) === null || _a === void 0 ? void 0 : _a.forEach(function (v, k) { return url.searchParams.set(k, v); });
        var pathList = [];
        pathList.push(market, routes[market][route]);
        if (options.path)
            pathList.push(options.path);
        url.pathname = pathList.join("/");
        return url;
    };
    return LoginRouter;
}());
export { LoginRouter };
